import { history } from "../redux/store";

export const showProject = projectId => {
  history.push(`/project/${projectId}`);
};
